import { render, staticRenderFns } from "./recentFiles.vue?vue&type=template&id=58c1cb80&"
import script from "./recentFiles.vue?vue&type=script&lang=js&"
export * from "./recentFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports